module.exports = __webpack_public_path__ + "img/arrow-down.2cc16874.svg";